import * as React from 'react';
import WeddingSpaces from './WeddingSpaces';
import FloorPlans from './FloorPlans';

import styles from './styles.module.scss';

const Spaces = () => {
    return (
        <div className={styles.section}>
            <WeddingSpaces />
            <FloorPlans />
        </div>
    );
};

export default Spaces;
